var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app min-h-screen text-white text-center px-4 py-10"},[_c('idioma'),_c('div',{staticClass:"flex-1 flex flex-col justify-center items-center"},[_vm._t("default")],2),_c('footer-base')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }